import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
} from "@angular/core";
import { Title, DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SaleService } from "../../../services/sale.service";
import { ShipmentService } from "../../../services/shipment.service";
import { UserService } from "../../../services/user.service";
import { Methods } from "../../../shared/methods";
import swal from "sweetalert2";

declare const $: any;

@Component({
  selector: "app-shipping",
  templateUrl: "./shipping.component.html",
  styleUrls: ["./shipping.component.css"],
  providers: [ShipmentService]
})
export class ShippingComponent implements OnInit {
  @Input() id: number;

  public shipments = [];
  public servicesCodeSelected: any = "*";
  public shippingweightunit = "ounce";
  public shippingdimensionsunit = "inch";
  public shippingweightvalue;
  public dimensionsheightvalue;
  public dimensionswidthvalue;
  public dimensionslengthvalue;
  public servicesCodeShipping = [];
  public carriers;
  public packages = [];

  public messageErrorShip;
  public showmsgerrorshipping: boolean = false;
  public showShipmentReady: boolean = false;
  public shipReady;

  public add_insurance = false;
  public insured_value_amount = '';
  public insured_value_currency = 'usd';

  constructor(
    public dialog: MatDialog,
    private _saleService: SaleService,
    private _shipmentService: ShipmentService
  ) {}

  ngOnInit() {
    this.load();
    this.getShippingCarriers();
  }

  load() {
    let token;
    token = JSON.parse(localStorage.getItem("token"));

    this._shipmentService.listbypo(token, this.id).subscribe((r) => {
      console.log(r);
      this.shipments = r.data;
    });
  }

  gotoship(data) {
    window.open("/shipments/detail/" + data + "", "_blank");
  }

  public pakageNum = 1;

  rem() {
    if (this.pakageNum > 1) {
      this.pakageNum--;
    }

  }

  add() {
    if (this.pakageNum < 10) {
      this.pakageNum++;
    }
  }

  addToPackage() {
    while (this.pakageNum >= 1 ) {
      let packagesend = {
        weight_value: this.shippingweightvalue,
        weight_unit: this.shippingweightunit,
        dimensions_height: this.dimensionsheightvalue,
        dimensions_width: this.dimensionswidthvalue,
        dimensions_length: this.dimensionslengthvalue,
        dimensions_unit: this.shippingdimensionsunit,
        insured_value_amount: this.insured_value_amount,
        insured_value_currency: this.insured_value_currency,
        add_insurance: this.add_insurance
      };
      this.packages.push(packagesend);
      this.pakageNum--;
    }
    this.pakageNum = 1;
    this.shippingweightvalue = "";
    this.dimensionsheightvalue = "";
    this.dimensionswidthvalue = "";
    this.dimensionslengthvalue = "";
    this.insured_value_amount =  '';
    this.insured_value_currency = 'usd';
    this.add_insurance = false;
  }

  openDialogAddItemsToBox(item): void {
    let dialogRef = this.dialog.open(AddInfoToBox, {
      width: "80%",
      data: { so_id: this.id, idpackage: item },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(showShippingDetails, {
      width: "80%",
      data: { shipment: this.shipReady },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }

  getShippingCarriers() {
    let me = this;

    this._shipmentService
      .listcarriers(JSON.parse(localStorage.getItem("token")))
      .subscribe((response) => {
        this.carriers = response.carriers;
        console.log(this.carriers);
        let item;
        for (item of this.carriers) {
          let servicio;
          for (servicio of item.services) {
            me.servicesCodeShipping.push(servicio.service_code);
          }
        }
        console.log(me.servicesCodeShipping);
      });
  }

  createShipment() {
    this.messageErrorShip = "";
    this.showmsgerrorshipping = false;

    this.showShipmentReady = false;

    let enviar = {
      service_code: this.servicesCodeSelected,
      packages: this.packages,
    };

    console.log(this.servicesCodeSelected);

    let me = this;

    this._shipmentService
      .create(JSON.parse(localStorage.getItem("token")), enviar, this.id)
      .subscribe((response) => {
        me.packages = [];
        me.shipReady = response.data;
        console.log(response);
        if (response.status == "success") {
          me.showShipmentReady = true;
          me.openDialog();
          me._shipmentService
            .listbypo(JSON.parse(localStorage.getItem("token")), this.id)
            .subscribe((response4) => {
              me.shipments = response4.data;
            });
        } else {
          me.messageErrorShip = response.msg;
          me.showmsgerrorshipping = true;
        }
      });
  }

  /*
  cancel() {
    this.edit = false;
    this.index = true;
    this.sale = new SaleOrder();
    this.sale.rep_id = this.identity.sub;
    this.total = 0;
    this.stock = 0;
    this.linesAgregados = [];
    this.arrayUnreserve = [];
    this.companyLinked = null;
    this.shipments = null;
    this.getAll();
  }
  */
}

@Component({
  selector: "shipping-detail",
  templateUrl: "shipping-details.html",
  styleUrls: ["./shipping.component.css"],
  providers: [UserService, ShipmentService],
})
export class showShippingDetails {
  public mtds: Methods = new Methods();
  public userinterno;
  public identity;
  public token;
  public innerHtml;
  public shipment;

  public packages;

  constructor(
    public dialogRef: MatDialogRef<showShippingDetails>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _shipmentService: ShipmentService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _sanitizer: DomSanitizer
  ) {
    console.log(data);
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.shipment = data.shipment;
    this.innerHtml = this._sanitizer.bypassSecurityTrustHtml(
      "<object style='width: 100%; height: 450px' data='" +
        this.shipment.labelDownloadHref +
        "' type='application/pdf' class='embed-responsive-item'>" +
        "Object " +
        this.shipment.labelDownloadHref +
        " failed" +
        "</object>"
    );
  }

  ngOnInit() {
    console.log(this.shipment);

    let me = this;

    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    } else {
      this._shipmentService
        .getshipmentspackages(this.token, this.shipment.id)
        .subscribe((response) => {
          console.log(response);

          me.packages = response.data;
        });
    }
  }

  valor(value) {
    return value.replace(/_/g, ' ');
  }

  public sendingmail = false;

  sendMail() {
    if (!this.sendingmail) {
      this.sendingmail = true;
      this._shipmentService.mailToCustomer(this.token, this.shipment.id).subscribe(
        (response) => {
          if (response.status === 'success') {
            swal.fire({
           
              title: "Success!",
              text: "Labels have been sent to " + response.email  + " address",
              buttonsStyling: false,

              customClass:{
    confirmButton: 'btn btn-success'
            },
            });
          } else {
            alert('Error! Something went wrong');
          }
          this.sendingmail = false;
        }, error => {
          alert('Error! Something went wrong');
          this.sendingmail = false;
        }
      );
    }
  }

  onSubmit() {}

  onNoClick(): void {}

  close() {
    this.dialogRef.close();
  }
}

@Component({
  selector: "add-items-to-box",
  templateUrl: "add-items-to-box.html",
  providers: [UserService, ShipmentService, SaleService],
})
export class AddInfoToBox {
  public mtds: Methods = new Methods();
  public identity;
  public token;
  public status_user;
  public privilegio;
  public companySelected = "";
  public companies;
  public company;

  public errors;
  public boxesInfo;
  public boxId;
  public so_id;
  public idpackage;

  public ordersNotShipped;

  public loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddInfoToBox>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _route: ActivatedRoute,
    private _router: Router,
    public dialog: MatDialog,
    private _saleService: SaleService,
    private _shipmentService: ShipmentService
  ) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.so_id = data.so_id;
    this.idpackage = data.idpackage;
    console.log(data);
  }

  ngOnInit() {
    let me = this;

    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    } else {
      this.loadOrderItems();

      this._shipmentService
        .detail(this.token, this.idpackage)
        .subscribe((response) => {
          console.log(response);

          me.boxesInfo = response.detail;
        });
    }
  }

  loadOrderItems() {
    let me = this;

    $("#waitloadOrderItems").show();
    this._saleService.getItemsNotShipped(this.so_id).subscribe((response) => {
      me.ordersNotShipped = response.data;

      $("#waitloadOrderItems").hide();
    });
  }

  getselectedOptions() {
    return this.ordersNotShipped
      .filter((opt) => opt.checked)
      .map((opt) => opt.id);
  }

  onSubmit() {
    let me = this;
    let itemsinbox = this.getselectedOptions();
    let enviar = {
      itemsinbox: itemsinbox,
      idpackage: this.boxId,
    };
    let token = JSON.parse(localStorage.getItem("token"));
    $("#successdiv").hide();

    this._shipmentService
      .additemstopackage(this.token, enviar, this.so_id)
      .subscribe((response) => {
        console.log(response);

        if (response.status == "error") {
          me.errors = response.data;
        } else if (response.status == "success") {
          $("#successdiv").show();
          this.loadOrderItems();
        }
      });
  }

  onNoClick(): void {}
}
